///<reference path="../common/smart-mover.models.ts"/>
///<reference path="report-manufacturers.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../collections/report-manufacturers.collection.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ReportManufacturersProductsDataTemplate extends ReportManufacturersDataTemplate implements IDataTemplate {
        protected products: ProductVariantsCollection;

        public totalSelectedMessage: string;
        public title: string;
        public allSelectedLabel: string;

        get leafCollection() {
            return this.products;
        }

        get collection() {
            return this.manufacturers;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options);

            this.products = new ProductVariantsCollection(this.model[this.properties[1]], [], {
                criteria: options.criteria,
                hiddenValue: options.hiddenValue,
                smartMoverHidden: () => this.smartMoverHidden
            });
            this.products.addFilters(...this.filters as IInteractiveFilter[]);
            this.products.setParentCollection(this.manufacturers, ProductVariantToManufacturerStrategy);
        }
    }
}
